import { UserTableAgent } from "../UserTableAgent";
import { UserTableCarrier } from "../UserTableCarrier";
import { UserTableCustomer } from "../UserTableCustomer";
import { UserTableDataFusion } from "../UserTableDataFusion";
import { UserTableDockOperator } from "../UserTableDockOperator";
import { UserTableDriver } from "../UserTableDriver";
import { UserTableFactoringCompany } from "../UserTableFactoringCompany";
import { UserTableFmVendor } from "../UserTableFmVendor";
import { UserTableLmeUser } from "../UserTableLmeUser";
import { UserTableLocation } from "../UserTableLocation";
import { UserTableMcControl } from "../UserTableMcControl";
import { UserTablePaymentApi } from "../UserTablePaymentApi";
import { DataSource, Layout, LayoutHeader, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutUserList extends Layout {
    layoutHeaderUserList: LayoutHeader;
    layoutUserTableAgent: UserTableAgent;
    layoutUserTableCarrier: UserTableCarrier;
    layoutUserTableCustomer: UserTableCustomer;
    layoutUserTableDataFusion: UserTableDataFusion;
    layoutUserTableDockOperator: UserTableDockOperator;
    layoutUserTableDriver: UserTableDriver;
    layoutUserTableFactoringCompany: UserTableFactoringCompany;
    layoutUserTableFmVendor: UserTableFmVendor;
    layoutUserTableLmeUser: UserTableLmeUser;
    layoutUserTableLocation: UserTableLocation;
    layoutUserTableMcControl: UserTableMcControl;
    layoutUserTablePaymentApi: UserTablePaymentApi;
    sourceUsers: DataSource;
    tabAgent: Tab;
    tabCarrier: Tab;
    tabCustomer: Tab;
    tabDataFusion: Tab;
    tabDockOperators: Tab;
    tabDriver: Tab;
    tabFactoringCompany: Tab;
    tabFmVendor: Tab;
    tabLmeUser: Tab;
    tabLocation: Tab;
    tabMcControl: Tab;
    tabPaymentApi: Tab;
    tabsetUsers: Tabset;
}
